import videojs from 'video.js';
const Component = videojs.getComponent('Component');
const ModalDialog = videojs.getComponent('ModalDialog');

const dom = videojs.dom || videojs;

const DEFAULTS = {

};

/**
 * The dialog component for showing moment Settings
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends ModalDialog
 */
class MomentsSettings extends ModalDialog {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options); 
		options_.uncloseable = true;
		super(player, options_);
		this.hide();
		this.init();
	}

	dispose() {
		this.options_.momentsList.dispose();
	}

	setListeners_() {
		this.on(this.$('.vjs-moments-settings-close'), 'click', () => {
			this.hide();
		});

		this.on(this.$('.vjs-moments-settings-accept'), 'click', () => {
			this.hide();
			this.options_.momentsList.showByTypes(this.getSelectedTypes());
		});
	}

	getSelectedTypes() {
		let res = [];
		let els = Array.prototype.slice.call(this.$$('.vjs-moments-settings-field-checkbox'));
		els.forEach((el) => {
			if (el.checked) {
				res.push(el.dataset.id);
			}
		});
		return res;
	}

	init() {
		this.fillWith(this.createContent());
		this.setListeners_();
	}

	createContent() {
		return [
			this.createClose_(),
			this.createHeading_(), 
			this.createDescription_(), 
			this.createFields_(),
			this.createButtons_()];
	}

	buildCSSClass() {
		return `vjs-moments-settings ${super.buildCSSClass()}`;
	}

	createClose_() {
		let close = dom.createEl('span', {
			className: 'vjs-moments-settings-close'
		});
		dom.insertContent(close, '\u00D7');
		return close;
	}

	createHeading_() {
		let heading = dom.createEl('div', {
			className: 'vjs-moments-settings-caption'
		}, {
			'role': 'heading'
		});
		dom.insertContent(heading, this.localize("Moments"));
		return heading;
	}

	createDescription_() {
		let desc = dom.createEl('div', {
			className: 'vjs-moments-settings-description'
		});
		dom.insertContent(desc, (this.localize("Select moments visible over timeline") + ':'));
		return desc;
	}

	createField_(type) {
		let fld = dom.createEl('div', {
			className: 'vjs-moments-settings-field'
		});

		let checkbox = dom.createEl('input', {
			className: 'vjs-moments-settings-field-checkbox',
			id: `vjs_moments_settings_field_${type.id}`,
			name: `vjs_moments_settings_field_${type.id}`
		}, {
			type: 'checkbox',
			'data-id': type.id
		});
		let typeFromList = this.options_.momentsList.types_[type.id];
		checkbox.checked = typeFromList ? typeFromList.selected : 0;

		let label = dom.createEl('label', {
			className: 'vjs-moments-settings-field-label'
		}, {
			for: `vjs_moments_settings_field_${type.id}`
		});

		let icon = dom.createEl('span', {
			className: 'vjs-moments-settings-fl-icon'
		},{
			style: `background-image: url(${type.icon})`
		});

		let text = dom.createEl('span', {
			className: 'vjs-moments-settings-fl-text'
		});
		dom.appendContent(text, type.name);
		dom.appendContent(label, [icon, text]);
		dom.appendContent(fld, [checkbox, label]);
		return fld;
	}

	createFields_() {
		let infoFields = dom.createEl('div', {
			className: 'vjs-moments-settings-fields'
		});

		this.options_.types.forEach((t) => {
			dom.appendContent(infoFields, this.createField_(t));
		});
		return infoFields;
	}

	createButtons_() {
		let btn = dom.createEl('input', {
			className: 'vjs-moments-settings-accept',
			value: this.localize('Accept moments settings')
		}, {
			type: 'button'
		});
		return btn;
	}
}

Component.registerComponent('MomentsSettings', MomentsSettings);
export default MomentsSettings;